/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const ElementRiveIcon = React.forwardRef<HTMLDivElement, BaseIconProps>(
  ({size = 16, ...props}, ref) => {
    return (
      <BaseIcon {...props} size={size} ref={ref}>
        <svg
          data-wf-icon="ElementRiveIcon"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <path
              d="M9.35742 2C11.2903 2.00015 12.8574 3.5671 12.8574 5.5C12.8574 7.01882 11.8894 8.31061 10.5371 8.79492L13.4189 13.2275L12.5811 13.7725L9.47656 8.99609C9.43699 8.99742 9.39732 9 9.35742 9H6.41309V8H9.35742C10.738 7.99985 11.8574 6.88062 11.8574 5.5C11.8574 4.11938 10.738 3.00015 9.35742 3H2.5V2H9.35742Z"
              fill="currentColor"
            />
          </g>
        </svg>
      </BaseIcon>
    );
  }
) as IconComponent;

ElementRiveIcon.tags = ['rive', 'r', 'animation'];

ElementRiveIcon.category = 'Navigator';

ElementRiveIcon.iconSize = 16;
